import * as Types from '../actions/ActionTypes';

const initialState = {
    popupAlert: { open: false, message: null, title: 'error', action: null, statusCode: 200 }
}

const PopupAlertReducer = function (state = initialState, action) {
    switch (action.type) {
        case Types.OPEN_POPUP: {
            return {
                ...state,
                popupAlert: action.payload,
            }
        }
        case Types.CLOSE_POPUP: {
            return {
                ...state,
                popupAlert: initialState.popupAlert,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default PopupAlertReducer
